import { ConfigurationSaga } from '../../interfaces/Configuration/Configuration'
import { ConfigurationAction } from '../actions/configurationActions'
import { GET_CONFIGURATION_EXITO } from '../types/configurationsActionsTypes'

export interface ConfigurationState {
  configurationState: {
    configuration: ConfigurationSaga[]
    error?: string | undefined
  }
}

const initialState: ConfigurationState = {
  configurationState: { configuration: [], error: '' }
}

export const configurationReducer = (
  state: ConfigurationState = initialState,
  action: ConfigurationAction
): ConfigurationState => {
  if (action.type === GET_CONFIGURATION_EXITO) {
    return {
      ...state,
      configurationState: {
        configuration: action.configuration,
        error: action.error
      }
    }
  }
  return state
}
